import React from 'react';
import styles from "./Radio.module.scss";

const Radio = ({ className, name, children, ...rest }) => {
    return (
        <>
            <div
                className={`${styles.radio} ${className || ""}`}
            >
                <input
                    {...rest}
                    name={name}
                    type="radio"
                    id={name}
                />
                <span />
                {children}
            </div>
        </>
    )
}

export default Radio
